<template>
    <section class="coming-soon content section">
        <img src="../../src/assets/images/coming soon.png" alt="image saka-saka" class="coming-img">
    </section>
</template>

<script>

    export default {
        name: "Coming-soon",
        components: {
            // Navbar,
            // Footer,
        },
        data() {
            return {

            };
        },
    }
</script>

<style scoped>

.coming-soon {
    text-align: center;
}

.coming-img {
    width: 500px;
}

</style>